import { gql, useMutation } from '@apollo/client';

import type {
  UpdateNotificationSettingsMutation,
  UpdateNotificationSettingsMutationVariables,
} from './__generated__/useUpdateNotificationSettings.gql';

// The selection must mirror every `notificationSettings` field the form reads —
// the type has no id, so Apollo replaces the whole sub-object on the normalized
// `User` and a field read but not selected here would silently go stale.
const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings($input: UpdateNotificationSettingsInput!) {
    updateNotificationSettings(input: $input) {
      id
      notificationSettings {
        activeHours {
          start
          end
        }
        timezone
        outreachTextOptedOut
        outreachEmailOptedOut
        textConsentRevoked
      }
    }
  }
`;

export const useUpdateNotificationSettings = () => {
  return useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(
    UPDATE_NOTIFICATION_SETTINGS
  );
};
